import {
  validatePhoneNumber,
  validateTkLength,
  validateWebSite,
  validateEmail,
} from 'utils';
import { Errors } from 'utils/errors';

export const formItems = [
  {
    name: 'name',
    id: 'input-first-name',
    label: 'Όνομα',
    placeholder: 'Εισάγετε το όνομά σας',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 12,
    rules: [{ required: true, message: Errors.FirstNameRequired }],
  },
  {
    name: 'lastname',
    id: 'input-last-name',
    label: 'Επώνυμο',
    placeholder: 'Εισάγετε το επώνυμό σας',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 12,
    rules: [{ required: true, message: Errors.LastNameRequired }],
  },
  {
    name: 'profession',
    id: 'input-profession',
    label: 'Επάγγελμα',
    placeholder: 'Εισάγετε το επάγγελμά σας',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 12,
    rules: [{ required: true, message: Errors.OccupationRequired }],
  },
  {
    name: 'phone',
    id: 'input-phone',
    label: 'Τηλέφωνο',
    className: 'form-input',
    placeholder: 'Εισάγετε τον αριθμό τηλεφώνου σας',
    type: 'text',
    asterisk: true,
    span: 12,
    rules: [
      { required: true, message: Errors.PhoneRequired },
      {
        validator: (_, value) => {
          if (!value || value.trim() === '') return Promise.resolve();
          return validatePhoneNumber(value, false);
        },
      },
    ],
  },
  {
    name: 'email',
    id: 'input-email',
    label: 'Email',
    placeholder: 'Εισάγετε το email σας',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 12,
    rules: [
      { required: true, message: Errors.EmailRequired },
      {
        validator: (_, value) => {
          if (!value || value.trim() === '') return Promise.resolve();
          return validateEmail(value, false);
        },
      },
    ],
  },
];

export const companyFields = [
  {
    name: 'companyName',
    id: 'input-company-name',
    label: 'Επωνυμία Επιχείρησης',
    placeholder: '-',
    type: 'text',
    className: 'form-input',
    disabled: true,
    span: 12,
  },
  {
    name: 'address',
    id: 'input-address',
    label: 'Οδός-Αριθμός Έδρας',
    placeholder: 'Εισάγετε τη διεύθυνση έδρας (οδός και αριθμός)',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 6,
    rules: [{ required: true, message: Errors.StreetNumberRequired }],
  },
  {
    name: 'postalCode',
    id: 'input-postal-code',
    label: 'Τ.Κ. Έδρας',
    placeholder: 'Εισάγετε τον ταχυδρομικό κώδικα έδρας',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 6,
    rules: [
      { required: true, message: Errors.PostalCodeRequired },
      {
        validator: (_, value) => {
          if (!value || value.trim() === '') return Promise.resolve();
          return validateTkLength(value, false);
        },
      },
    ],
  },
  {
    name: 'afm',
    id: 'input-afm',
    label: 'ΑΦΜ Επιχείρησης',
    type: 'text',
    className: 'form-input',
    disabled: true,
    span: 12,
  },
  {
    name: 'region',
    id: 'input-region',
    label: 'Περιοχή Έδρας',
    placeholder: 'Εισάγετε την περιοχή της έδρας',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 6,
    rules: [{ required: true, message: Errors.RegionRequired }],
  },
  {
    name: 'doy',
    id: 'input-doy',
    label: 'ΔΟΥ',
    placeholder: 'Εισάγετε τη ΔΟΥ της επιχείρησης',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 6,
    rules: [{ required: true, message: Errors.TaxOfficeRequired }],
  },
  {
    name: 'kad',
    id: 'input-kad',
    label: 'ΚΑΔ Κύριας Δραστηριότητας',
    placeholder: 'Εισάγετε τον ΚΑΔ κύριας δραστηριότητας',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 12,
    rules: [{ required: true, message: Errors.ActivityCodeRequired }],
  },
  {
    name: 'companyPhone',
    id: 'input-company-phone',
    label: 'Τηλέφωνο',
    placeholder: 'Εισάγετε το τηλέφωνο της επιχείρησης',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 12,
    rules: [
      { required: true, message: Errors.PhoneRequired },
      {
        validator: (_, value) => {
          if (!value || value.trim() === '') return Promise.resolve();
          return validatePhoneNumber(value, false);
        },
      },
    ],
  },
  {
    name: 'foundingDate',
    id: 'input-founding-date',
    label: 'Ημερομηνία Ίδρυσης',
    type: 'date',
    className: 'form-input',
    component: 'datepicker',
    disabled: true,
    span: 12,
  },
  {
    name: 'website',
    id: 'input-website',
    label: 'Ιστοχώρος',
    placeholder: 'Εισάγετε ιστόχωρο',
    type: 'text',
    className: 'form-input',
    span: 12,
    rules: [
      {
        validator: (_, value) => {
          if (!value || value.trim() === '') return Promise.resolve();
          return validateWebSite(value, false);
        },
      },
    ],
  },
  {
    name: 'legalForm',
    id: 'select-legal-form',
    label: 'Νομική Μορφή',
    className: 'form-select',
    component: 'select',
    type: 'select',
    size: 'large',
    disabled: true,
    span: 12,
    customization: true,
  },
  {
    name: 'companyEmail',
    id: 'input-company-email',
    label: 'Email',
    placeholder: 'Εισάγετε το email της επιχείρησης',
    type: 'text',
    className: 'form-input',
    asterisk: true,
    span: 12,
    rules: [{ required: true, message: Errors.EmailRequired }],
  },
  {
    name: 'displayValue',
    id: 'select-company-size',
    label: 'Μέγεθος Επιχείρησης',
    className: 'form-select',
    component: 'select',
    type: 'select',
    placeholder: 'Επιλέξτε μέγεθος επιχείρησης',
    disabled: true,
    size: 'large',
    span: 12,
    customization: true,
    options: [
      { id: 'small', value: 'Μικρή', label: 'Μικρή' },
      { id: 'medium', value: 'Μεσαία', label: 'Μεσαία' },
      { id: 'large', value: 'Μεγάλη', label: 'Μεγάλη' },
    ],
    rules: [{ required: true, message: 'Απαιτείται μέγεθος επιχείρησης' }],
  },
];
